/**
 * Slug ↔ filter mapping for programmatic SEO category routes.
 * Both parcel and project data are indexed by these slugs.
 */

// Location slug → {label, corridors[]}. corridors=null means "match all corridors".
export const LOCATION_SLUGS = {
  "bengaluru":   { label: "Bengaluru",   region: "Karnataka", corridors: null },
  "bangalore":   { label: "Bangalore",   region: "Karnataka", corridors: null },
  "karnataka":   { label: "Karnataka",   region: "Karnataka", corridors: null },
  "devanahalli": { label: "Devanahalli", region: "Karnataka", corridors: ["Devanahalli"] },
  "sarjapur":    { label: "Sarjapur",    region: "Karnataka", corridors: ["Sarjapur"] },
  "whitefield":  { label: "Whitefield",  region: "Karnataka", corridors: ["Whitefield"] },
  "hoskote":     { label: "Hoskote",     region: "Karnataka", corridors: ["Hoskote"] },
  "bidadi":      { label: "Bidadi",      region: "Karnataka", corridors: ["Bidadi"] },
  "dommasandra": { label: "Dommasandra", region: "Karnataka", corridors: ["Dommasandra"] },
};

// Property-type slug → {label, parcelConv?, projectPropType?}
export const TYPE_SLUGS = {
  "agricultural-land":   { label: "Agricultural Land",   parcelConv: ["Agricultural"] },
  "residential-plots":   { label: "Residential Plots",   parcelConv: ["Residential Master Plan", "Converted NA"], projectPropType: ["Plot", "Independent Land Parcel"] },
  "residential-land":    { label: "Residential Land",    parcelConv: ["Residential Master Plan", "Converted NA"], projectPropType: ["Plot", "Independent Land Parcel"] },
  "commercial-land":     { label: "Commercial Land",     parcelConv: ["Industrial"] },
  "industrial-land":     { label: "Industrial Land",     parcelConv: ["Industrial"] },
  "apartments":          { label: "Apartments",          projectPropType: ["Apartment"] },
  "villas":              { label: "Villas",              projectPropType: ["Villa"] },
  "plots":               { label: "Plots",               projectPropType: ["Plot"], parcelConv: ["Converted NA", "Residential Master Plan"] },
  "independent-land":    { label: "Independent Land Parcels", projectPropType: ["Independent Land Parcel"], parcelConv: ["Agricultural", "Converted NA"] },
  "all-properties":      { label: "Properties" },
};

export function resolveLocation(slug) {
  return LOCATION_SLUGS[String(slug || "").toLowerCase()] || null;
}
export function resolveType(slug) {
  return TYPE_SLUGS[String(slug || "").toLowerCase()] || null;
}

export function filterParcels(parcels, loc, typ) {
  return parcels.filter((p) => {
    if (loc?.corridors && !loc.corridors.includes(p.corridor_location)) return false;
    if (typ?.parcelConv && !typ.parcelConv.includes(p.conversion_status)) return false;
    // If the type slug is projects-only (no parcelConv), exclude parcels
    if (typ && !typ.parcelConv && typ.projectPropType) return false;
    return true;
  });
}
export function filterProjects(projects, loc, typ) {
  return projects.filter((p) => {
    if (loc?.corridors) {
      const loc_l = p.location.toLowerCase();
      if (!loc.corridors.some((c) => loc_l.includes(c.toLowerCase()))) return false;
    }
    if (typ?.projectPropType && !typ.projectPropType.includes(p.property_type)) return false;
    // If the type slug is parcels-only (no projectPropType), exclude projects
    if (typ && !typ.projectPropType && typ.parcelConv) return false;
    return true;
  });
}

// All (location, type) combinations we consider valid for internal-linking / sitemap.
export const CATEGORY_COMBOS = (() => {
  const combos = [];
  for (const [locSlug, loc] of Object.entries(LOCATION_SLUGS)) {
    for (const [typSlug, typ] of Object.entries(TYPE_SLUGS)) {
      combos.push({ locSlug, typSlug, label: `${typ.label} in ${loc.label}` });
    }
  }
  return combos;
})();
